// extracted by css-extract-rspack-plugin
export default {"cls1":"BlurredResults-cls1_3r6","cls2":"BlurredResults-cls2_stL BlurredResults-cls1_3r6"};